<template>
  <div class="NoTripsResult">
    <Icon
      class="NoTripsResult-icon"
      :icon="icon"
      size="lg"
    />
    <div class="NoTripsResult-content">
      <p class="NoTripsResult-title">
        {{ title }}
      </p>

      <p class="NoTripsResult-description">
        {{ description }}
      </p>
    </div>

    <ActionButton
      v-if="actionLabel"
      data-testid="no-trips-results-button"
      @click="emit('action')"
    >
      {{ actionLabel }}
    </ActionButton>
  </div>
</template>

<script setup lang="ts">
import ActionButton from '../../atoms/ActionButton/ActionButton.vue';
import Icon from '../../atoms/Icon/Icon.vue';
import type { NoTripsResultProps } from './NoTripsResult.model';

defineProps<NoTripsResultProps>();

const emit = defineEmits<{
  action: [];
}>();
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/text';

@layer cvo-ui {
  .NoTripsResult {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: vars.$dimensions-d-6;
    padding-block: vars.$dimensions-d-5;
    text-align: center;
    color: vars.$color-neutral-gray-700;

    &-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: vars.$dimensions-d-4;
    }

    &-title {
      @include text.heading(h5);
      color: vars.$patterns-tripresults-diclaimer-title-color;
    }

    &-description {
      @include text.text(sm);
      color: vars.$patterns-tripresults-diclaimer-subtitle-color;
    }
  }
}
</style>
